import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import uploadfile from '@/components/mapv2/uploadfile';
import mapPosition from '@/components/mapv2/positiongroup';
import sliderInput from '@/components/mapv2/sliderinput';
import fontStyle from '@/components/mapv2/fontstyle';
import gpickr from '@/components/mapv2/gpickr';
import linkwh from '@/components/mapv2/linkwidthheight';
import typebtn from '@/components/mapv2/typebtn';
import pointtext from '@/components/mapv2/pointtext';
import pointicon from '@/components/mapv2/pointicon';
import cdata from './common.js';
import { mapState, mapGetters, mapMutations } from 'vuex';
import mapdisplay from '@/components/mapv2/display';
import { formfileHandle } from "@/utils/utils";
import fillcolor from '@/components/mapv2/fillcolor';
import mapshadow from '@/view/map/hdmconfigv2/mapshadow';
export default {
  name: 'slidedata',
  components: {
    uploadfile,
    mapPosition,
    sliderInput,
    fontStyle,
    gpickr,
    linkwh,
    typebtn,
    pointtext,
    pointicon,
    mapdisplay,
    fillcolor,
    mapshadow
  },
  meta: {
    title: ''
  },
  emits: ['basic', 'fileList', 'point', 'type', 'launch', 'routetype', 'route', 'typeIndex', 'switchNav', 'openSource', 'shadowList'],
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: {}
    },
    formlabel: {
      type: Object,
      default: {}
    },
    formoption: {
      type: Object,
      default: {}
    },
    formfield: {
      type: Object,
      default: {}
    },
    style: {
      type: Object,
      default: {}
    },
    seniordata: {
      type: Object,
      default: {}
    },
    pointlist: {
      type: Array,
      default: []
    },
    typelist: {
      type: Array,
      default: []
    },
    isadd: {
      type: Boolean,
      default: true
    },
    routetypelist: {
      type: Array,
      default: []
    },
    routelist: {
      type: Array,
      default: []
    },
    maptemplate: {
      type: Number,
      default: 0
    },
    decorationstruct: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      leftSlideArr: [],
      // 左侧导航数据
      leftIndex: 0,
      // 左侧导航索引
      leftconflag: true,
      // 展开收缩配置面板
      typeOptions: [],
      // 分类模版选项
      typeStyleIndex: 0,
      // 分类模版索引
      pointOptions: [],
      // 点位样式选项
      pointStyleIndex: 0,
      // 点位样式索引
      pointItem: {},
      // 点位当前样式
      popOptions: [],
      // 弹窗样式选项
      popStyleIndex: 0,
      // 弹窗样式索引
      senior: {
        visit: false,
        service: false,
        footerinfo: '',
        effect: false,
        draw: false,
        reset: false
      },
      activeNames: [],
      titleInfo: [],
      checkList: ['0', '1'],
      switchtab1: 'first',
      switchtab2: 'first',
      switchtab3: 'first',
      textarea2: '',
      pointkey: '',
      listOptions: [],
      // 列表样式选项
      listStyleIndex: 0,
      // 列表样式索引
      fillimagesOptions: [],
      // 填充图片模版选项
      fillimageindex: 1,
      // 填充图片模版索引
      fillcolorIndex: 999,
      defaultupImg: require('@/assets/mapv2/defaultImage.jpg'),
      decorationtype: {
        0: 'icon-landscape',
        1: 'icon-plant',
        2: 'icon-other'
      },
      decorationIndex: '',
      decorationList: []
    };
  },
  created() {
    console.log(`create`);
    this.leftSlideArr = cdata.MenuData;
    let collapseLen = 38;
    for (let i = 0; i < collapseLen; i++) {
      this.activeNames.push((i + 1).toString());
    }
    this.titleInfo = cdata.MenuData;
    this.typeOptions = cdata.typeData;
    this.pointOptions = cdata.pointStyle;
    this.popOptions = cdata.popStyle;
    this.listOptions = cdata.listStyle;
    this.fillimagesOptions = cdata.fillimageData;
    if (this.isadd) {
      this.typeStyleChange('', 0);
      this.SET_MAPSTYLEITEM({
        typeStyleIndex: this.typeStyleIndex
      });
      this.pointItem = this.pointOptions[this.pointStyleIndex];
      this.SET_MAPSTYLEITEM({
        pointStyleIndex: this.pointStyleIndex
      });
      this.SET_MAPSTYLEITEM({
        popStyleIndex: this.popStyleIndex
      });
      this.SET_MAPSTYLEITEM({
        listStyleIndex: this.maptemplate === 1 ? 1 : this.listStyleIndex
      });
    } else {
      console.log(`create`, this.style);
      this.SET_MAPSTYLEITEM({
        typeStyleIndex: this.style.typeStyleIndex
      });
      this.pointItem = this.pointOptions[this.style.pointStyleIndex];
      this.SET_MAPSTYLEITEM({
        pointStyleIndex: this.style.pointStyleIndex
      });
      this.SET_MAPSTYLEITEM({
        popStyleIndex: this.style.popStyleIndex
      });
      this.SET_MAPSTYLEITEM({
        listStyleIndex: this.style.listStyleIndex
      });
    }
  },
  computed: {
    ...mapGetters(['mapv2info']),
    activeroute() {
      return this.routetypelist.map((item, index) => {
        return index;
      });
    }
  },
  watch: {
    'style.pointStyleIndex': {
      handler(val) {
        if (val !== undefined) this.pointStyleIndex = val;
      },
      deep: true
    },
    'style.popStyleIndex': {
      handler(val) {
        if (val !== undefined) this.popStyleIndex = val;
      },
      deep: true
    },
    'style.typeStyleIndex': {
      handler(val) {
        if (val !== undefined) this.typeStyleIndex = val;
      },
      deep: true
    },
    'style.listStyleIndex': {
      handler(val) {
        if (val !== undefined) this.listStyleIndex = val;
      },
      deep: true
    },
    // 'style.pointpic': {
    //   handler (val) {
    //     console.log(`slidedata_style_pointpic`, val)
    //   },
    // },
    // 'form.fillcolor': {
    //   handler (val) {
    //     // 初始化操作 只限1次
    //     if (val && !this.form.fillcolor) {
    //       console.log(`form.fillcolor`)
    //       console.log(val)
    //       this.form.fillcolor = val
    //     }
    //   },
    //   deep: true
    // },
    'mapv2info.form.fillimageindex': {
      handler(val) {
        this.fillimageindex = val;
      },
      deep: true
    },
    'mapv2info.form.fillcolorIndex': {
      handler(val) {
        if (val) {
          console.log(`mapv2info.form.fillcolorIndex`, val);
          this.fillcolorIndex = val;
        }
      },
      deep: true
    }
  },
  mounted() {
    if (Object.keys(this.seniordata).length === 0) {
      this.seniorChange();
    } else {
      this.senior = this.seniordata;
    }
    if (Object.keys(this.style).length > 0) {
      this.pointStyleIndex = this.style.pointStyleIndex;
      this.pointItem = this.pointOptions[this.pointStyleIndex];
      // this.SET_MAPSTYLEITEM({pointStyleIndex: this.pointStyleIndex})
      this.typeStyleIndex = this.style.typeStyleIndex;
      this.popStyleIndex = this.style.popStyleIndex;
    }
    // 非遗版本 点位样式 只显示图片样式
    if (this.form.cTemplateScore === 1) {
      this.pointItem = this.pointOptions[1];
      this.pointStyleIndex = 1;
      this.SET_MAPSTYLEITEM({
        pointStyleIndex: 1
      });
      this.popStyleIndex = this.isadd ? 1 : this.style.popStyleIndex;
      this.SET_MAPSTYLEITEM({
        popStyleIndex: this.popStyleIndex
      });
    }
    this.fillimageindex = this.form.fillimageindex;
    if (this.decorationstruct.length > 0) this.setdecoration(this.decorationstruct);
  },
  methods: {
    ...mapMutations(['SET_MAPSTYLEITEM', 'SET_MAPSENIOR', 'SET_MAPFORMITEM', 'SET_MAPSENIORTIEM']),
    inputChange(val, title) {
      let obj = {};
      obj[title] = val;
      console.log(`val`, val);
      if (title === 'fillimageindex') this.fillimageindex = val;
      this.$emit('basic', obj);
    },
    fileListHandle(val, title) {
      let obj = {};
      obj[title] = formfileHandle(val, 'imagebox', this.$route.query.uid);
      if (title === 'routemoveicon') {
        this.SET_MAPSTYLEITEM(obj);
      } else {
        this.SET_MAPFORMITEM(obj);
      }
      this.$emit('fileList', obj);
    },
    handleClick() {},
    handleChange(e) {
      // console.log(e)
    },
    fontChange(val) {
      this.SET_MAPSTYLEITEM(val);
      this.$emit('fontstyle', val);
    },
    typeStyleChange(item, index) {
      this.typeStyleIndex = index;
      let obj = {
        typeStyleIndex: index
      };
      this.SET_MAPFORMITEM(obj);
      this.$emit('typeIndex', obj);
    },
    pointStyleChange(item, index) {
      this.pointStyleIndex = index;
      this.pointItem = item;
      this.SET_MAPSTYLEITEM({
        pointStyleIndex: index
      });
    },
    popStyleChange(item, index) {
      console.log(`popStyleChange`, index);
      this.popStyleIndex = index;
      this.SET_MAPSTYLEITEM({
        popStyleIndex: index
      });
    },
    popColorHandle(val, name) {
      this.style[name] = val;
      this.SET_MAPSTYLEITEM({
        [name]: val
      });
    },
    seniorChange(val, name) {
      let obj = {};
      obj[name] = val;
      this.SET_MAPSENIORTIEM(obj);
    },
    pointhandle(type, data) {
      let obj = {
        type: type
      };
      if (data) obj.data = data;
      this.$emit('point', obj);
    },
    typehandle(type, data) {
      let obj = {
        type: type
      };
      if (data) obj.data = data;
      this.$emit('type', obj);
    },
    listStyleChange(item, index) {
      this.listStyleIndex = index;
      console.log(`this.listStyleIndex`, this.listStyleIndex);
      this.SET_MAPSTYLEITEM({
        listStyleIndex: index
      });
    },
    launchHandle() {
      this.leftconflag = !this.leftconflag;
      this.$emit('launch', this.leftconflag);
    },
    switchSlide(index) {
      if (this.leftIndex !== index) this.$emit('switchNav', this.leftIndex);
      this.leftIndex = index;
    },
    routetypehandle(type, data) {
      let obj = {
        type: type
      };
      if (data) obj.data = data;
      this.$emit('routetype', obj);
    },
    routehandle(type, data) {
      let obj = {
        type: type
      };
      if (data) obj.data = data;
      this.$emit('route', obj);
    },
    getRouteItem(arr, id) {
      return arr.filter(elem => {
        return elem.itemformdata.typeId === id;
      });
    },
    displayHandle(val) {
      this.SET_MAPSTYLEITEM(val);
    },
    fillcolorChange(val) {
      this.SET_MAPFORMITEM({
        fillcolor: val
      });
    },
    confirmClip(val) {
      this.SET_MAPFORMITEM({
        clipflag: false
      });
      this.SET_MAPFORMITEM({
        clipflag: true
      });
    },
    adjustExtent() {
      this.SET_MAPFORMITEM({
        adjustextent: false
      });
      this.SET_MAPFORMITEM({
        adjustextent: true
      });
    },
    pichandleDragStart(event) {
      event.dataTransfer.setData('text/plain', 0);
      this.$parent.pichandleDragStart(event, {
        type: 'picture'
      });
    },
    openSourceMaterial(type) {
      let obj = {
        type: type
      };
      if (type === 0) {
        obj.pic = !this.isMobile ? this.form.background_img : this.form.app_bg_img;
      }
      this.$emit('openSource', obj);
    },
    opentypeSourceMaterial(data) {
      this.$emit('openSource', data);
    },
    /**
     * 选择类型素材库返回事件
     * @date 2025-06-18
     */
    changetypePic(data) {
      this.$refs.typebtn.changePic(data);
    },
    mapShadowList(data) {
      this.$emit('shadowList', data);
    },
    /**
     * 获取地图装饰分类
     * @date 2025-07-10
     */
    setdecoration(val) {
      console.log(`setdecoration`, val);
      const decoration = val.find(item => {
        return item.alias === 'decoration_type';
      });
      this.decorationList = decoration.field.options.map(item => {
        return {
          title: item.title,
          id: item.score,
          icon: this.decorationtype[item.score]
        };
      });
    },
    /**
     * 地图装饰分类选择
     * @date 2025-07-10
     */
    decorationHandle(item, index) {
      this.decorationIndex = index;
      this.$parent.decorationHandle(item);
    }
  }
};